import { useNavigate } from 'react-router-dom';

const BONavigationButton = ({ navigationRoute = 0, text }) => {
	const navigate = useNavigate();

	return (
		<button
			type="button"
			onClick={() => navigate(navigationRoute)}
			className="transition duration-300 bg-primary hover:bg-primary/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary/70 text-white px-4 py-2 rounded-lg"
		>
			{text}
		</button>
	);
};

export default BONavigationButton;
